export default function HTMLText({ content }) {
  return (
    <div dangerouslySetInnerHTML={{ __html: content }} className="article-text"></div>
  );
}
